export class UserGridViewModel {
    constructor() {
        this.firstName = "";
        this.lastName = "";
        this.emailId = "";
        this.roles = "";
        this.organization = "";
    }
}
export default class UserGridView extends UserGridViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
